import { useState } from 'react';
import axios from 'axios';

const useAddimtContract = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const addimtContract = async (formData) => {
    setLoading(true);
    setSuccess(false);
    setError('');
  
  try {
    const response = await axios.post('https://niaserver-05287f289508.herokuapp.com/imtContract/insert', formData);
    console.log('API Response:', response.data);
  
    if (response.data.success) {
      setSuccess(true);
      return { success: true }; 
      } else {
      setError('Failed to add the data. Please try again.');
      return { success: false }; 
      }
    } catch (err) {
      console.error('Error submitting data:', err);
      setError('Something went wrong. Please try again later.');
      return { success: false };
    } finally {
      setLoading(false);
    }
  };
  

  return {
    loading,
    success,
    error,
    addimtContract,
  };
};

export default useAddimtContract;
